


















































import Vue from 'vue';
import moment from 'moment';
import { CloseFullscreenWrapper, TriggerRefreshError } from '@/mixins';
import { dateFormat, datePickerFormat } from '@/constants';
import {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenLoading,
  FullscreenSuccess,
  FullscreenError,
} from '@/components/fullscreen-wrapper-components';
import { ExtendMixins } from '@/services';
import { AddReleaseAuthorizationFormModel, MemberARIsResponseModel } from '@/@types/member';

interface Data {
  isLoading: boolean;
  showSuccessMessage: boolean;
  successMessage: string;
  showErrorMessage: boolean;
  errorMessage: string;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  TriggerRefreshError,
).extend({
  name: 'RemoveReleaseAuthorization',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      showSuccessMessage: false,
      successMessage: this.params.successMessage,
      showErrorMessage: false,
      errorMessage: this.params.errorMessage,
    };
  },
  computed: {
    ariDesignees(): MemberARIsResponseModel[] {
      return this.$store.getters.ariDesignees;
    },
    currentARI(): MemberARIsResponseModel {
      const ariIndex = this.ariDesignees.findIndex((ari) => {
        return ari.id === this.params.id;
      });
      return ariIndex > -1 ? this.ariDesignees[ariIndex] : null;
    },
  },
  methods: {
    constructPayload(): AddReleaseAuthorizationFormModel {
      return {
        id: this.currentARI.id,
        firstName: this.currentARI.firstName,
        lastName: this.currentARI.lastName,
        startDate: this.currentARI.startDate,
        endDate: moment().format(datePickerFormat),
      };
    },
    removeARIDesignee(): void {
      this.isLoading = true;
      this.$store
        .dispatch('updateARIDesignee', this.constructPayload())
        .then(() => {
          this.refreshARIDesignees();
        })
        .catch(() => {
          // @ts-ignore
          this.confirmBeforeClose = false;
          this.showErrorMessage = true;
          this.isLoading = false;
        });
    },
    refreshARIDesignees(): void {
      this.$store
        .dispatch('getARIDesignees')
        .then(() => {
          // @ts-ignore
          this.confirmBeforeClose = false;
          this.showSuccessMessage = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.triggerRefreshError({
            message: [
              'remove-ari_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenContent,
    FullscreenLoading,
    FullscreenSuccess,
    FullscreenError,
  },
});
